import GoogleLoginHelper from "adminUsers/GoogleLoginHelper";
import Ajax from "base/Ajax";

export default class GoogleLoginProvider {
    static async authenticate() {
        let googleUser = await GoogleLoginHelper.authorize();

        return this.submitLogin(googleUser.getAuthResponse().id_token);
    }

    static async submitLogin(id_token) {
        return await Ajax.post("adminUsers", "login", {
            provider: "google",
            id_token,
        });
    }

    static async initialise() {
        return GoogleLoginHelper.initialise(window.CONFIG.adminUsers.providers.google);
    }
}
